import { Injectable } from "@angular/core";
import { InstanceModel } from "../model/instance.model";
import { ResourceService } from "./resource.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { GlobalSettings } from "../model/settings.model";
import { AuthenticationService } from "./auth.service";
import { SearchParamsModel } from "../model/search-params.model";
import { UserService } from "./user.service";

@Injectable({
    providedIn: 'root'
})
export class InstanceQueryService extends ResourceService<InstanceModel> {

    constructor(
        http: HttpClient,
        settings: GlobalSettings,
        authService: AuthenticationService) {
            super(http, "reports", settings.reportUrl, authService)
    }

    getCurrentSteps(...filters: string[]): Observable<InstanceModel> {
        return this.getWithComplement(`CurrentSteps/?${this.getFormattedParams("filter", filters)}`)
    }

    getCurrentStepsByFilter(searchParams: SearchParamsModel): Observable<InstanceModel[]> {
        let params = new HttpParams()

        Object.keys(searchParams).forEach(function (key) {
            if(key != "processesIds" &&
                key != "filter" &&
                key != "roles" &&
                searchParams[key] &&
                searchParams[key] != "") {
                    params = params.set(key, searchParams[key]);
                }
        });

        if(searchParams.processesIds) {
            searchParams.processesIds.forEach(function (value) {
                params = params.append("processesIds", value);
            });
        }

        if(searchParams.filter) {
            searchParams.filter.forEach(function (value) {
                params = params.append("filter", value);
            });
        }

        if(searchParams.roles) {
            searchParams.roles.forEach(function (value) {
                params = params.append("roles", value);
            });
        }

        let query = `CurrentStepByFilter?${params.toString()}`

        return this.getWithComplement(query)
    }

    getStatus(processesIds: string[]): Observable<InstanceModel[]> {
        return this.getWithComplement(`CurrentStepByFilter/?filter=status&filter=link&${this.getFormattedParams("processesIds", processesIds)}`)
    }
}